<div class="splash-screen">
  @if (true) {
    <div class="desktop" [class.desktop]="isDesktop()">
      <div class="error-image-container">
        <img
          alt="banner-maintenance"
          src="assets/images/banner-maintenance.png"
        />
      </div>
      <div class="desktop-maintenance">
        <p class="heading-maintenance">
          {{ i18n.langString("banner_heading_maintenance") }}
        </p>
        <p class="text-maintenance">
          {{ i18n.langString("banner_maintenance_text1") }}
        </p>
        <p class="text-maintenance">
          {{ i18n.langString("banner_maintenance_text2") }}
        </p>
      </div>
    </div>
  }

  <!-- @if (isMobile() || isTablet()) {
      <div
        class="mobile"
        [class.mobile]="isMobile()"
        [class.tablet]="isTablet()"
      >
        <div class="error-image-container">
          <img
            alt="banner-maintenance"
            src="assets/images/banner-maintenance.png"
          />
        </div>
        <div class="mobile-maintenance">
          <p class="heading-maintenance">
            {{ i18n.langString("banner_heading_maintenance") }}
          </p>
          <p class="text-maintenance">
            {{ i18n.langString("banner_maintenance_text1") }}
          </p>
          <p class="text-maintenance">
            {{ i18n.langString("banner_maintenance_text2") }}
          </p>
        </div>
      </div>
    } -->
</div>
